import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { handleFormChange } from '@/src/updateProfile/redux/actions';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border: 1px solid ${colors.accentGrayMedium};
    }
  `,
  selectContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.white};
      border: 1px solid ${colors.accentGrayMedium};
    }
  `,
};

const Country = props => {
  const { form, info, updateProfile, currentInfo, key, onChange } = props;
  const {
    label,
    persist,
    meta,
    field,
    formOverrides = {},
    options = [],
    optionId,
    optionDesc,
  } = info;
  const { isOtherCountryVisible } = updateProfile;

  const countryChange = e => {
    if (e === 'Other') {
      props.handleFormChange('isOtherCountryVisible', true);
    } else {
      props.handleFormChange('isOtherCountryVisible', false);
    }
  };

  useEffect(() => {
    if (updateProfile.CountryCode === 'Other') {
      props.handleFormChange('isOtherCountryVisible', true);
    }
  }, []);

  return (
    <>
      <div key={optionId} css={styles.selectContainer}>
        <Form.Item
          label="Country"
          extra="Note: If your country does not appear in the list, select Other and enter the country name in the box that appears below."
        >
          {form.getFieldDecorator('CountryCode', {
            initialValue: updateProfile['CountryCode'],
            ...formOverrides,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              allowClear
              onChange={e => {
                countryChange(e);
                onChange(field, e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
            >
              {options.map(option => (
                <Option key={`${field}-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherCountryVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="Enter Country">
            {form.getFieldDecorator('Country', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter Country.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('Country', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

Country.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default connect(
  mapStateToProps,
  { handleFormChange }
)(Country);
